import { toJS } from "mobx";
import { observer } from "mobx-react";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { PAGE_SIZE_DEFAULT } from "utils/constants";
import { formatNumber } from "utils/formatHelper";
import { useResizableColumns } from "utils/reportHelper";

// components
import { debounce } from "@mui/material";
import TemplateReportModal from "base/ui/components/Modal/TemplateReportModal";
import Wrapper from "base/ui/components/Wrapper";
import { AiOutlineDownload } from "react-icons/ai";
import SaveReportForm from "../reportComponents/reportForm";
import SearchCollapse from "../reportComponents/searchCollapse";

import { SearchModel } from "./models";

// Store - presenter
import { ListDate, ListStatusProduct } from "services/commonDate_services";
import { BC03, ListKeynValue } from "services/report_services";
import {
  commonDatePresenter,
  commonDateStore,
  reportPresenter,
  reportStore,
} from "stores/root_store";
import "./style.css";

// antd
import { ActionType, ProColumns } from "@ant-design/pro-components";
import {
  Tooltip as AntdTooltip,
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Spin,
  Tag
} from "antd";
import CustomProTable from "base/ui/components/CustomTable";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import type { CustomTagProps } from "rc-select/lib/BaseSelect";
import { FaInfoCircle } from 'react-icons/fa';
import ModalDetail from './ModalDetail';

// data dropdown tiến độ đơn hàng
const orderProcessData = [
  {
    // màu đỏ
    key: 3,
    value: "Đúng tiến độ",
    // subValue: "Ngày hoàn thành SX dự kiến theo ghi nhận thực tế < (Ngày YC nhập kho - 3)",
    subValue: "Ngày hiện tại < (Ngày YC nhập kho - 3)",
    color: "#389e0d",
  },
  {
    // màu vàng
    key: 1,
    value: "Chú ý tiến độ",
    // subValue: "(Ngày YC nhập kho - 3) <= Ngày hoàn thành SX dự kiến theo ghi nhận thực tế < (Ngày YC nhập kho - 1)",
    subValue: "(Ngày YC nhập kho - 3) <= Ngày hiện tại < (Ngày YC nhập kho - 1)",
    color: "#feda7a",
  },
  {
    // màu đỏ
    key: 0,
    value: "Trễ tiến độ",
    // subValue: "(Ngày YC nhập kho - 1) <= Ngày hoàn thành SX dự kiến theo ghi nhận thực tế",
    subValue: "(Ngày YC nhập kho - 1) <= Ngày hiện tại",
    color: "#dd5d5e",
  },
];
// chú thích công đoạn
const chuThichCongDoan = [
  {
    // màu đỏ
    key: 3,
    value: "Công đoạn đã hoàn thành",
    color: "#389e0d",
  },
  {
    // màu vàng
    key: 1,
    value: "Công đoạn đang thực hiện",
    color: "#90e0ef",
  },
  {
    // màu đỏ
    key: 0,
    value: "Công đoạn chưa thực hiện",
    color: "#ffff",
  },
];

// data dropdown tình trạng hàng
const statusPrdData = [
  {
    key: "CHUAIN",
    value: "Chưa in xong",
  },
  {
    key: "DAIN",
    value: "Hàng đã về xưởng",
  },
];

// tag color
const tagRender = (props: CustomTagProps) => {
  const { label, value, closable, onClose } = props;
  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={
        value === "Đúng tiến độ"
          ? "green"
          : value === "Chú ý tiến độ"
            ? "yellow"
            : "red"
      }
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {label}
    </Tag>
  );
};


const initialSearch: SearchModel = {
  paging: {
    pageSize: PAGE_SIZE_DEFAULT,
    pageIndex: 1,
    orderByDesc: "",
    orderBy: "",
  },
  // lsxTongHop: "",
  // lsx: [],
  // tpbtp: "",
  trangThaiMES: ["INPROGRESS"],
  // trangThaiMESName: "Đang sản xuất",
  // ngayGiaoHangDuKienTu: undefined,
  // ngayGiaoHangDuKienDen: undefined,
  // ngayRaLSXTu: undefined,
  // ngayRaLSXDen: undefined,
  // lsxVeSinh: false,
  // TH : Tổng hợp , CT : chi tiết
  type: "TH",
}

export function createStuckWarning() {
  return observer(() => {
    //==========================Loading ===================//
    // Loading của cả trang nếu gửi api thì cho loading
    const [loading, setLoading] = useState(true);
    // loading khi search
    const [isLoading, setIsLoading] = useState(false);
    const [formSearch] = Form.useForm()
    //========================================================//

    // lấy danh sách cho bảng báo cáo
    const [dataTable, setDataTable] = useState<BC03[]>([]);
    // Thông tin tìm kiếm , phân trang và sort
    const [search, setSearch] = useState<SearchModel>(initialSearch);
    // lưu lại search CT hay TH khi bấm search
    const [typeSearchPrev, setTypeSearchPrev] = useState("TH");
    // dropdown khách hàng
    const [dropdownCustomer, setDropdownCustomer] = useState<ListStatusProduct[]>([])

    // danh sách date
    const [listCommonDate, setListCommonDate] = useState<ListDate[]>([]);
    // Danh sách common date dự kiến
    const [listCommonDateFuture, setListCommonDateFuture] = useState<
      ListDate[]
    >([]);
    // danh sách LSX
    // list status danh sach trang thai
    const [listStatus, setListStatus] = useState<ListKeynValue[]>([]);

    // Ngày ban hành wo
    const commonNgayRaLSX = Form.useWatch('commonNgayRaLSX', formSearch)
    // Ngày Y/C giao hàng theo SO
    const commonNgayGiaoHangDuKien = Form.useWatch('commonNgayGiaoHangDuKien', formSearch)
    // Ngày Y/C nhập kho theo KH
    const commonNgayYeuCauNhapKho = Form.useWatch('commonNgayYeuCauNhapKho', formSearch)
    // Ngày hoàn thành SX dự kiến theo ghi nhận thực tế
    const commonNgayDuKienHoanThanhLSX = Form.useWatch('commonNgayDuKienHoanThanhLSX', formSearch)

    // =================================================================================//
    // lấy dang sách report
    const getListReport = async (dataSearch = search) => {
      // setDataTable([]);
      setIsLoading(true)
      await reportPresenter.getDataBC03(reportStore, dataSearch);

      if (reportStore.BC03Response.isSuccess) {
        //  kiểm tra type để set datatable và render column
        // Nếu là TH thì set data table như cũ và render các bước ở column
        if (dataSearch.type === "TH") {
          setDataTable(() =>
            reportStore.BC03Response.data.map((data, index) => ({
              ...data,
              key: data.stt,
            }))
          );
          setTypeSearchPrev("TH");
          // render thêm các cột bước
          handleRender(toJS(reportStore.BC03Response.data));
        }
        // nếu là chi tiết thì thêm các cột chỉ hiểm thị ở chi tiết
        // covert data lại để hiện thị row tổng
        else if (dataSearch.type === "CT") {
          setTypeSearchPrev("CT");
          const data = reportStore.BC03Response.data.map((item, idx) => ({
            ...item,
            key: `${item.stt}`,
            children: item.chiTietBaoCao?.map((value, index) => {
              return { ...value, key: `${item.stt}.${index + 1}` };
            }),
          }));

          data.forEach((i) => {
            if (i.children) {
              i.children.push({
                key: `${i.stt}.${i.children.length + 1}`,
                // soGioChenhLech: i.chiTietBaoCao?.reduce((a, b) => {
                //   return a + (b.soGioChenhLech || 0);
                // }, 0),
                // soPhutChenhLech: i.chiTietBaoCao?.reduce((a, b) => {
                //   return a + (b.soPhutChenhLech || 0);
                // }, 0),
                soGioSXKH: i.tongSoGioSXKH,
                soPhutSXKH: i.tongSoPhutSXKH,
                soGioSXTT: i.tongSoGioSXTT,
                soPhutSXTT: i.tongSoPhutSXTT,
                soGioConLaiKeHoach: i.tongSoGioConLaiKeHoach,
                soPhutConLaiKeHoach: i.tongSoPhutConLaiKeHoach,
                soGioConLai3: i.tongSoGioConLaiThucTe,
                soPhutConLai3: i.tongSoPhutConLaiThucTe,
                thuTuCongDoan: "Tổng cộng",
                soGioTreTienDo: i.tongSoGioTreTienDo,
                soPhutTreTienDo: i.tongSoPhutTreTienDo,
                // tyLeChenhLech: i.chiTietBaoCao?.reduce((a, b) => {
                //   return a + (b.tyLeChenhLech || 0);
                // }, 0),
              });
            }
          });

          setDataTable(data);
          // Vấn đề gặp phải: bất đồng bộ khi lưu mẫu báo cáo , nếu lấy initColumn để gán lại cho column thì sẽ mất width
          // vì vậy phải lấy lấy width của resizableColumnSelect gán qua cho initColumn. => map initColumn dể tìm các item giống nhau trong resizableColumnSelect
          // Ẩn 3 cột tg đã sx kế hoạch, tg đã sx thực tế, tg còn lại bên chi tiết công đoạn
          const columnTemp = cloneDeep(columns);

          if (typeSearchPrev !== "CT") {
            columnTemp.map((ct) => {
              if (ct.hideInTable === false) {
                ct.hideInTable = true;
                ct.hideInSetting = true;
                return ct;
              } else if (ct.hideInTable === true) {
                ct.hideInTable = false;
                ct.hideInSetting = false;
                return ct;
              }
              return ct;
            });
            setColumns(columnTemp);
          }
        }
      }
      setIsLoading(false)
      return [];
    };

    // hàm render các bước trong data table
    const handleRender = (data: BC03[]) => {
      let max = 0;
      let index = 0;
      data.forEach((item, i) => {
        if (item.listRouting && item.listRouting.length > max) {
          max = item.listRouting?.length;
          index = i;
        }
      });
      if (data.length && data[index].listRouting) {
        const steps = data[index].listRouting?.map((step, idx) => {
          return {
            title: `Bước ${idx + 1}`,
            width: 200,
            key: `Buoc${idx + 1}`,
            // ellipsis: {
            //   showTitle: false,
            // },
            render: (value: string, record: BC03) => (
              <>
                {record.listRouting && record.listRouting.length > idx ? (
                  <div className='flex gap-2 justify-between'>
                    {/* <AntdTooltip
                      placement="topLeft"
                      title={record.listRouting[idx]?.tenCongDoan}
                    > */}
                    <div>
                      <span className='font-semibold'>
                        {record.listRouting[idx]?.thuTuCongDoan} - {record.listRouting[idx]?.tenCongDoan}
                      </span>
                      {/* </AntdTooltip> */}
                      <span className={`ml-1 font-semibold`}>
                        {/* {formatNumber(record.listRouting[idx].tiLeHoanThanh, 2)}% */}
                        | {record.listRouting[idx].tiLeHoanThanhNew}
                      </span>
                    </div>

                    <div onClick={() => {
                      setModalOpen(true)
                      setCurrentList(record.listRouting?.[idx].equipments || [])
                    }} className='cursor-pointer' style={{
                      display: record.listRouting[idx].isYellow ? 'block' : 'none'
                    }}><FaInfoCircle
                        style={{
                          color: record.listRouting && record.listRouting.length > idx ? record.listRouting[idx].isYellow ? '#fb5607' : '#000' : '#000'
                        }}
                        className='text-lg' /></div>
                  </div>
                ) : (
                  <div></div>
                )}
              </>
            ),
            onCell: (record: BC03) => ({
              style: {
                background:
                  // Kiểm tra có listRouting và kiểm tra listRouting có vị trí index không bằng cách so sánh chiều dài của listRouting và index
                  record.listRouting && record.listRouting.length > idx
                    ? record.listRouting[idx].mau
                    : "#D1D5DB",
                // color: record.listRouting && record.listRouting.length > idx ? record.listRouting[idx].isYellow ? '#fb5607' : '#000' : '#000'
              },
            }),
          };
        });
        // initColumn.push(...(tempt as ProColumns<BC03>[]));
        const columnTemp = cloneDeep(columns);
        const indxStep = columnTemp.findIndex((c) => c.key === "buoc");
        if (indxStep !== -1) {
          Object.assign(columnTemp[indxStep], { children: steps });

          if (typeSearchPrev !== "TH") {
            columnTemp.map((ct) => {
              if (ct.hideInTable === false) {
                ct.hideInTable = true;
                ct.hideInSetting = true;
                return ct;
              } else if (ct.hideInTable === true) {
                ct.hideInTable = false;
                ct.hideInSetting = false;
                return ct;
              }
              return ct;
            });
          }
          setColumns(columnTemp);
        }
      }
    };


    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonDatePresenter.getListCommonDate(commonDateStore);
      setListCommonDate(commonDateStore.listDate.data);
    };
    // Lấy danh sách common date Future
    const getListCommonDateFuture = async () => {
      await commonDatePresenter.getListCommonDate(commonDateStore, "Future");
      setListCommonDateFuture(commonDateStore.listDate.data);
    };

    // Lấy danh sách khách hàng
    const getListCustomer = async (keword?: string) => {
      await commonDatePresenter.getListCustomer(commonDateStore, keword);
      if (commonDateStore.listStatusProductResponse.isSuccess) {
        setDropdownCustomer(commonDateStore.listStatusProductResponse.data)
      }
    }

    const searchCustomer = useCallback(debounce(getListCustomer, 500), []);


    // =================================================================================//

    useEffect(() => {
      const getData = async () => {
        await getListCommonDate();
        await getListCommonDateFuture();
        getListCustomer()
      };
      getData();
      const getListStatus = async () => {
        await commonDatePresenter.getDropdownByKeyword(
          commonDateStore,
          "WorkOrderStatusMes"
        );

        setListStatus(commonDateStore.dropdownByKey);
      };
      getListStatus();
      formSearch.setFieldsValue(initialSearch)
    }, []);




    // In the fifth row, other columns are merged into first column
    // by setting it's colSpan to be 0
    const sharedOnCell = (record: any, index: number | undefined) => {
      if (record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng") {
        return {
          backgroundColor:
            record.thuTuCongDoan === "Tổng cộng" ? "#D9E1F2" : "white",
        };
      }
      return {};
    };

    // Tìm kiếm
    const handleSearch = async () => {
      setIsLoading(true);
      const dataSearch: SearchModel = {
        ...search,
        paging: { ...search.paging, pageIndex: 1 },
      };
      setSearch(dataSearch);
      await getListReport(dataSearch);
      setIsLoading(false);
    };

    //=======================================Table Report ANTD =============================================//
    const [columns, setColumns] = useState<ProColumns<BC03>[]>([
      {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 50,
        fixed: "left",
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Loại LSX
      // {
      //   title: "Loại LSX",
      //   dataIndex: "loaiLSX",
      //   key: "loaiLSX",
      //   width: 100,
      //   fixed: "left",
      // },

      // Ghép bài/Lệnh TK
      // {
      //   title: "Ghép bài/Lệnh TK",
      //   dataIndex: "ghepBaiLTK",
      //   key: "ghepBaiLTK",
      //   width: 150,
      //   sorter: true,
      //   fixed: "left",
      //   onCell: (record, index) => ({
      //     children: record.ghepBaiLTK,
      //   }),
      // },
      // Khách hàng
      {
        title: "Khách hàng",
        dataIndex: "khachHang",
        key: "khachHang",
        width: 200,
        className: "!py-1",
        ellipsis: true,
        fixed: "left",
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Mã TP/BTP
      {
        title: "Mã TP/BTP",
        dataIndex: "maTPBTP",
        key: "maTPBTP",
        width: 150,
        sorter: true,
        fixed: "left",
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Tên TP/BTP
      {
        title: "Tên TP/BTP",
        dataIndex: "tenTPBTP",
        key: "tenTPBTP",
        width: 200,
        className: "!py-1",
        fixed: "left",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // số SO
      {
        title: "Số SO",
        dataIndex: "soCode",
        key: "soCode",
        width: 200,
        className: "!py-1",
        ellipsis: true,
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // số lượng PO
      {
        title: "Số lượng PO",
        dataIndex: "poQuantity",
        key: "poQuantity",
        width: 100,
        className: "!py-1",
        ellipsis: true,
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Số lượng yêu cầu sx của SO (Số lượng SO)
      {
        title: "Số lượng SO",
        dataIndex: "soLuongYeuCauSXSO",
        key: "soLuongYeuCauSXSO",
        width: 100,
        sorter: true,
        className: "text-right",
        valueType: "money",
        fieldProps: {
          moneySymbol: false,
          precision: 0,
        },
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Ngày ban hành SO
      {
        title: "Ngày ban hành SO",
        dataIndex: "soDate",
        key: "soDate",
        width: 200,
        sorter: true,
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY HH:mm:ss",
        },
        render(dom, entity) {
          return dom;
        },
        onCell: (text, record) => ({
          style: {
            textAlign: "center",
            ...sharedOnCell(text, record)
          },
        }),
      },
      // LSX TH (Lệnh sản xuất tổng hợp)  (Số WO tổng hợp)
      {
        title: "Số WO tổng hợp",
        dataIndex: "lsxTongHop",
        key: "lsxTongHop",
        width: 130,
        sorter: true,
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // LSX (Lệnh sản xuất) Số WO
      {
        title: "Số WO",
        dataIndex: "lsx",
        key: "lsx",
        width: 100,
        sorter: true,
        onCell: (record, index) => ({
          className: `!font-bold`,
          style: {
            color:
              record.trangThaiLSX === "Đóng lệnh" ||
                record.trangThaiLSX === "Tạm ngưng"
                ? "inherit"
                : `${record.mauTienDoDonHang}`,
            ...sharedOnCell(record, index)
          },
          children: <span>{record.lsx}</span>,
        }),
      },
      // Loại LSX (Loại lệnh sản xuất)
      {
        title: "Loại lệnh sản xuất",
        dataIndex: "loaiLSX",
        key: "loaiLSX",
        width: 100,
        sorter: true,
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Số lượng yêu cầu sản xuất của kế hoạch
      {
        title: "Số lượng yêu cầu sản xuất của kế hoạch",
        dataIndex: "quantity",
        key: "quantity",
        width: 130,
        sorter: true,
        className: "text-right",
        valueType: "money",
        fieldProps: {
          moneySymbol: false,
          precision: 0,
        },
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Số lượng bù hao WO
      {
        title: "Số lượng bù hao WO",
        dataIndex: "buHaoWO",
        key: "buHaoWO",
        width: 130,
        sorter: true,
        className: "text-right",
        valueType: "money",
        fieldProps: {
          moneySymbol: false,
          precision: 0,
        },
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // SL phát lệnh (Số lượng WO)
      {
        title: "Số lượng WO",
        dataIndex: "slPhatLenh",
        key: "slPhatLenh",
        width: 130,
        sorter: true,
        className: "text-right",
        valueType: "money",
        fieldProps: {
          moneySymbol: false,
          precision: 0,
        },
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Tỉ lệ chênh lệch số lượng WO/SL\nyêu cầu sản xuất của KH
      {
        title: "Tỉ lệ chênh lệch số lượng WO/SL\nyêu cầu sản xuất của KH",
        dataIndex: "tiLeChenhLech",
        key: "tiLeChenhLech",
        width: 160,
        sorter: true,
        className: "text-right",
        render(text, entity) {
          return text !== '-' ? `${formatNumber(Number(text), 0)}%` : text
        },
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // Ngày ra lệnh (Ngày ra LSX) (Ngày ban hành WO)
      {
        title: "Ngày ban hành WO",
        dataIndex: "ngayRaLSX",
        key: "ngayRaLSX",
        width: 200,
        sorter: true,
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY HH:mm:ss",
        },
        render(dom, entity) {
          return dom;
        },
        onCell: (text, record) => ({
          style: {
            textAlign: "center",
            ...sharedOnCell(text, record)
          },
        }),
      },
      // Trạng thái lệnh (Trạng thái WO)
      {
        title: "Trạng thái WO",
        dataIndex: "trangThaiLSX",
        key: "trangThaiLSX",
        width: 150,
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // (Số lượng thực tế nhập kho)
      {
        title: "Số lượng thực tế nhập kho",
        dataIndex: "slThucTeCDC",
        key: "slThucTeCDC",
        width: 120,
        className: "text-right",
        valueType: "money",
        fieldProps: {
          moneySymbol: false,
          precision: 0,
        },
        render: (text, record) => {
          return "slThucTeCDC" in record
            ? record.slThucTeCDC
              ? formatNumber(record.slThucTeCDC, 1)
              : 0
            : "-";
        },
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // ĐVT
      {
        title: "ĐVT",
        dataIndex: "dvt",
        key: "dvt",
        width: 60,
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      //======== CHI TIẾT ===========================
      // thứ tự công đoạn
      {
        title: "Thứ tự công đoạn",
        dataIndex: "thuTuCongDoan",
        key: "thuTuCongDoan",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) =>
          text !== "Tổng cộng" ? (
            text
          ) : (
            <div className="!font-bold">{text}</div>
          ),
        onCell: (record: any, rowIndex) => {
          return {
            style: {
              textAlign: "right",
              backgroundColor:
                record.thuTuCongDoan === "Tổng cộng" ? "#D9E1F2" : "white",
            },
            // colSpan:
            //   record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
            //     ? 8
            //     : 1,
          };
        },
      },
      // công đoạn
      {
        title: "Công đoạn",
        dataIndex: "congDoan",
        key: "congDoan",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => text,
        onCell: (text, record) => ({
          style: {
            ...sharedOnCell(text, record)
          }
        }),
      },
      // ===========================================
      // Ngày GH DK (Ngày nhập kho) (Ngày y/c nhập kho theo SO)
      {
        title: "Ngày y/c nhập kho",
        dataIndex: "ngayGiaoHang",
        key: "ngayGiaoHang",
        width: 200,
        sorter: true,

        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY",
        },
        onCell: (text, record) => ({
          style: {
            textAlign: "center",
            ...sharedOnCell(text, record)
          },
        }),
        render(dom, entity, index, action, schema) {
          return dom;
        },
      },
      // //Ngày y/c nhập kho(Theo Kế Hoạch)
      // {
      //   title: "Ngày y/c nhập kho\n(Theo Kế Hoạch)",
      //   dataIndex: "ngayYeuCauNhapKho",
      //   className: "!py-1 whitespace-pre-line",
      //   key: "ngayYeuCauNhapKho",
      //   width: 200,
      //   sorter: true,
      //   valueType: "dateTime",
      //   fieldProps: {
      //     format: "DD/MM/YYYY HH:mm:ss",
      //   },
      //   render(dom, entity) {
      //     return dom;
      //   },
      //   onCell: (text, record) => ({
      //     style: {
      //       textAlign: "center",
      //       ...sharedOnCell(text, record)
      //     },
      //   }),
      // },
      //  Ngày hoàn thành SX dự kiến theo ghi nhận
      {
        title: "Ngày hoàn thành SX dự kiến theo ghi nhận thực tế\n(Theo dữ liệu đầu vào thực tế)",
        dataIndex: "ngayHoanThanhSXDuKien",
        className: "!py-1 whitespace-pre-line",
        key: "ngayHoanThanhSXDuKien",
        width: 200,
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY HH:mm:ss",
        },
        onCell: (text, record) => ({
          style: {
            textAlign: "center",
            ...sharedOnCell(text, record)
          },
        }),
        render(dom, entity, index, action, schema) {
          return entity.trangThaiLSX === "Đóng lệnh" ||
            entity.trangThaiLSX === "Tạm ngưng"
            ? entity.trangThaiLSX
            : dom;
        },
      },
      // (Tổng Thời gian hoàn thành SX\n(theo định mức))
      {
        title: "Tổng Thời gian hoàn thành SX\n(theo định mức)",
        className: "!py-1 whitespace-pre-line",
        hideInTable: false,
        hideInSetting: false,
        key: 'tgSXTheoKH',
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioSXTheoKH",
            key: "soGioSXTheoKH",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },
            render: (text, record) =>
              typeof text === "number"
                ? record.soGioSXTheoKH
                  ? formatNumber(record.soGioSXTheoKH, 0)
                  : 0
                : "-",
            onCell: (text, record) => ({
              style: {
                textAlign: "right",
                ...sharedOnCell(text, record)
              },
            }),
          },
          {
            title: "Phút",
            dataIndex: "soPhutSXTheoKH",
            key: "soPhutSXTheoKH",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },
            render: (text, record) =>
              typeof text === "number"
                ? record.soPhutSXTheoKH
                  ? formatNumber(record.soPhutSXTheoKH, 0)
                  : 0
                : "-",
            onCell: (text, record) => ({
              style: {
                textAlign: "right",
                ...sharedOnCell(text, record)
              },
            }),
          },
        ],
      },
      // Thời gian đã sản xuất đơn hàng theo ghi nhận thực tế
      {
        title:
          "Thời gian đã sản xuất đơn hàng theo ghi nhận thực tế",
        className: "!py-1 whitespace-pre-line",
        key: "tgDaSXThucTe",
        hideInTable: false,
        hideInSetting: false,
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioDaSXThucTe",
            key: "soGioDaSXThucTe",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },

            render: (text, record) =>
              typeof text === "number"
                ? record.soGioDaSXThucTe
                  ? formatNumber(record.soGioDaSXThucTe, 0)
                  : 0
                : "-",
            onCell: (text, record) => ({
              style: {
                textAlign: "right",
                ...sharedOnCell(text, record)
              },
            }),
          },
          {
            title: "Phút",
            dataIndex: "soPhutDaSXThucTe",
            key: "soPhutDaSXThucTe",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },
            render: (text, record) =>
              typeof text === "number"
                ? record.soPhutDaSXThucTe
                  ? formatNumber(record.soPhutDaSXThucTe, 0)
                  : 0
                : "-",
            onCell: (text, record) => ({
              style: {
                textAlign: "right",
                ...sharedOnCell(text, record)
              },
            }),
          },
        ],
      },

      // --=============== CHI TIẾT ==============================================================
      //Thời gian đã sản xuất (Kế Hoạch)\n(Các công đoạn sau gia công in)
      {
        title:
          "Tổng Thời gian hoàn thành SX\n(theo định mức)",
        className: "!py-1 whitespace-pre-line",
        hideInTable: true,
        hideInSetting: true,
        key: "tgdasxKHCCDSI",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioSXKH",
            key: "soGioSXKH",
            width: 150,
            className: "!py-1",
            render: (text, record: any) =>
              typeof text === "number" ? (
                record.thuTuCongDoan === "Tổng cộng" ? (
                  <div className="font-bold">
                    {formatNumber(Number(text), 0)}
                  </div>
                ) : (
                  formatNumber(Number(text), 0)
                )
              ) : (
                "-"
              ),
            onCell: (record: any) => ({
              style: {
                textAlign: "right",
                backgroundColor:
                  record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
                    ? "#D9E1F2"
                    : "white",
              },
            }),
          },
          {
            title: "Phút",
            dataIndex: "soPhutSXKH",
            key: "soPhutSXKH",
            width: 150,
            className: "!py-1",
            render: (text, record: any) =>
              typeof text === "number" ? (
                record.thuTuCongDoan === "Tổng cộng" ? (
                  <div className="font-bold">
                    {formatNumber(Number(text), 0)}
                  </div>
                ) : (
                  text
                )
              ) : (
                "-"
              ),
            onCell: (record: any) => ({
              style: {
                textAlign: "right",
                backgroundColor:
                  record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
                    ? "#D9E1F2"
                    : "white",
              },
            }),
          },
        ],
      },
      // Thời gian đã sản xuất (Thực tế)\n(Các công đoạn sau gia công in, có tính canh máy và vệ sinh)
      {
        title:
          "Thời gian đã sản xuất đơn hàng theo ghi nhận thực tế",
        className: "!py-1 whitespace-pre-line",
        key: "tgdasxTTCCDSGCICTCMVVS",
        hideInTable: true,
        hideInSetting: true,
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioSXTT",
            key: "soGioSXTT",
            width: 150,
            className: "!py-1",
            render: (text, record: any) =>
              typeof text === "number" ? (
                record.thuTuCongDoan === "Tổng cộng" ? (
                  <div className="font-bold">
                    {formatNumber(Number(text), 0)}
                  </div>
                ) : (
                  formatNumber(Number(text), 0)
                )
              ) : (
                "-"
              ),
            onCell: (record: any) => ({
              style: {
                textAlign: "right",
                backgroundColor:
                  record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
                    ? "#D9E1F2"
                    : "white",
              },
            }),
          },
          {
            title: "Phút",
            dataIndex: "soPhutSXTT",
            key: "soPhutSXTT",
            width: 150,
            className: "!py-1",
            render: (text, record: any) =>
              typeof text === "number" ? (
                record.thuTuCongDoan === "Tổng cộng" ? (
                  <div className="font-bold">
                    {formatNumber(Number(text), 0)}
                  </div>
                ) : (
                  text
                )
              ) : (
                "-"
              ),
            onCell: (record: any) => ({
              style: {
                textAlign: "right",
                backgroundColor:
                  record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
                    ? "#D9E1F2"
                    : "white",
              },
            }),
          },
        ],
      },
      // ==========================================================================================
      // Thời gian trễ tiến độ
      {
        title:
          "Thời gian trễ tiến độ",
        className: "!py-1 whitespace-pre-line",
        key: "tgTreTienDo",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioTreTienDo",
            key: "soGioTreTienDo",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },

            render: (text, record) =>
              typeof text === "number"
                ? record.soGioTreTienDo
                  ? formatNumber(record.soGioTreTienDo, 0)
                  : 0
                : "-",
            onCell: (text, record) => ({
              style: {
                textAlign: "right",
                ...sharedOnCell(text, record)
              },
            }),
          },
          {
            title: "Phút",
            dataIndex: "soPhutTreTienDo",
            key: "soPhutTreTienDo",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },
            render: (text, record) =>
              typeof text === "number"
                ? record.soPhutTreTienDo
                  ? formatNumber(record.soPhutTreTienDo, 0)
                  : 0
                : "-",
            onCell: (text, record) => ({
              style: {
                textAlign: "right",
                ...sharedOnCell(text, record)
              },
            }),
          },
        ],
      },
      // Ngày yêu cầu có hàng in
      // {
      //   title: "Ngày yêu cầu có hàng in",
      //   dataIndex: "ngayYeuCauCoHangIn",
      //   key: "ngayYeuCauCoHangIn",
      //   width: 200,
      //   sorter: true,
      //   valueType: "dateTime",
      //   fieldProps: {
      //     format: "DD/MM/YYYY HH:mm:ss",
      //   },
      //   render(dom, entity, index, action, schema) {
      //     return dom;
      //   },
      //   onCell: (record) => ({
      //     style: {
      //       textAlign: "center",
      //     },
      //   }),
      // },
      // Tỷ lệ hoàn thành(LSX)
      // {
      //   title: "Tỷ lệ hoàn thành (LSX)(%)",
      //   dataIndex: "tyLeHoanThanhLSX",
      //   key: "tyLeHoanThanhLSX",
      //   width: 100,
      //   valueType: "money",
      //   className: "text-right",
      //   fieldProps: {
      //     moneySymbol: false,
      //     precision: 0,
      //   },
      //   render: (text, record) =>
      //     "tyLeHoanThanhLSX" in record
      //       ? record.tyLeHoanThanhLSX
      //         ? formatNumber(record.tyLeHoanThanhLSX, 2)
      //         : `0`
      //       : "-",
      // },

      // Thời gian đã sản xuất (Kế Hoạch)\n(Các công đoạn sau gia công in)
      // {
      //   title:
      //     "Thời gian đã sản xuất (Kế Hoạch)\n(Các công đoạn sau gia công in)",
      //   className: "!py-1 whitespace-pre-line",
      //   key: "tgDaSXKeHoach",
      //   hideInTable: false,
      //   hideInSetting: false,
      //   children: [
      //     {
      //       title: "Giờ",
      //       dataIndex: "soGioDaSXKeHoach",
      //       key: "soGioDaSXKeHoach",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },
      //       render: (text, record) =>
      //         typeof text === "number"
      //           ? record.soGioDaSXKeHoach
      //             ? formatNumber(record.soGioDaSXKeHoach, 0)
      //             : 0
      //           : "-",
      //       onCell: (record) => ({
      //         style: {
      //           textAlign: "right",
      //         },
      //       }),
      //     },
      //     {
      //       title: "Phút",
      //       dataIndex: "soPhutDaSXKeHoach",
      //       key: "soPhutDaSXKeHoach",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },

      //       render: (text, record) =>
      //         typeof text === "number"
      //           ? record.soPhutDaSXKeHoach
      //             ? formatNumber(record.soPhutDaSXKeHoach, 0)
      //             : 0
      //           : "-",
      //       onCell: (record) => ({
      //         style: {
      //           textAlign: "right",
      //         },
      //       }),
      //     },
      //   ],
      // },

      // Thời gian còn lại\n(Tính theo số lượng phát lệnh của các công đoạn sau gia công in)
      // {
      //   title:
      //     "Thời gian còn lại\n(Tính theo số lượng phát lệnh của các công đoạn sau gia công in)",
      //   className: "!py-1 whitespace-pre-line",
      //   key: "tgConLai",
      //   hideInTable: false,
      //   hideInSetting: false,
      //   children: [
      //     {
      //       title: "Giờ",
      //       dataIndex: "soGioConLai",
      //       key: "soGioConLai",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },
      //       render: (text, record) =>
      //         "soGioConLai" in record
      //           ? record.soGioConLai
      //             ? formatNumber(record.soGioConLai, 0)
      //             : 0
      //           : "-",
      //       onCell: (record) => ({
      //         style: {
      //           textAlign: "right",
      //         },
      //       }),
      //     },
      //     {
      //       title: "Phút",
      //       dataIndex: "soPhutConLai2",
      //       key: "soPhutConLai2",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },
      //       render: (text, record) =>
      //         "soPhutConLai2" in record
      //           ? record.soPhutConLai
      //             ? formatNumber(record.soPhutConLai, 0)
      //             : 0
      //           : "-",
      //       onCell: (record) => ({
      //         style: {
      //           textAlign: "right",
      //         },
      //       }),
      //     },
      //   ],
      // },
      // Thời gian còn lại\n(Tính theo sản lượng thực tế của các công đoạn sau gia công in)
      // {
      //   title:
      //     "Thời gian còn lại\n(Tính theo sản lượng thực tế của các công đoạn sau gia công in)",
      //   className: "!py-1 whitespace-pre-line",
      //   key: "tgConLai2",
      //   hideInTable: false,
      //   hideInSetting: false,
      //   children: [
      //     {
      //       title: "Giờ",
      //       dataIndex: "soGioConLai2",
      //       key: "soGioConLai2",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },
      //       render: (text, record) =>
      //         "soGioConLai2" in record
      //           ? record.soGioConLai2 !== null
      //             ? formatNumber(record.soGioConLai2, 0)
      //             : "-"
      //           : "-",
      //       onCell: (record) => ({
      //         style: {
      //           textAlign: "right",
      //         },
      //       }),
      //     },
      //     {
      //       title: "Phút",
      //       dataIndex: "soPhutConLai2",
      //       key: "soPhutConLai2",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },
      //       render: (text, record) =>
      //         "soPhutConLai2" in record
      //           ? record.soPhutConLai2 !== null
      //             ? formatNumber(record.soPhutConLai2, 0)
      //             : "-"
      //           : "-",
      //       onCell: (record) => ({
      //         style: {
      //           textAlign: "right",
      //         },
      //       }),
      //     },
      //   ],
      // },

      // Bước
      {
        title: "Bước",
        key: "buoc",
        dataIndex: "buoc",
        hideInTable: false,
        hideInSetting: false,
        children: [],
      },
      // =================CHI TIẾT ===============================================
      // sản lượng kế hoạch
      // {
      //   title: "Sản lượng kế hoạch",
      //   dataIndex: "slKeHoach",
      //   key: "slKeHoach",
      //   width: 150,
      //   className: "!py-1",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   render: (text, record: any) => ({
      //     props: {
      //       style: {
      //         textAlign: "right",
      //       },
      //     },
      //     children: text && text !== "-" ? formatNumber(Number(text), 0) : "-",
      //   }),
      //   onCell: (text, record) => sharedOnCell(text, record),
      // },
      // Sản lượng thực tế
      // {
      //   title: "Sản lượng thực tế đạt",
      //   dataIndex: "slThucTeDat",
      //   key: "slThucTe",
      //   width: 150,
      //   className: "!py-1",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   render: (text, record: any) => ({
      //     props: {
      //       style: {
      //         textAlign: "right",
      //       },
      //     },
      //     children:
      //       text !== null && text !== "-" ? formatNumber(Number(text), 1) : "-",
      //   }),
      //   onCell: (text, record) => sharedOnCell(text, record),
      // },
      // Số lượng còn lại (SLKH-SLTT)
      // {
      //   title: "Số lượng còn lại (SLKH-SLTT)",
      //   dataIndex: "slConLai",
      //   key: "slConLai",
      //   width: 150,
      //   className: "!py-1",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   render: (text, record) => ({
      //     props: {
      //       style: {
      //         textAlign: "right",
      //       },
      //     },
      //     children: text && text !== "-" ? formatNumber(Number(text), 1) : "-",
      //   }),
      //   onCell: (text, record) => sharedOnCell(text, record),
      // },
      // Tỷ lệ hoàn thành công đoạn (%)
      // {
      //   title: "Tỷ lệ hoàn thành công đoạn (%)",
      //   dataIndex: "tyLeHoanThanh",
      //   key: "tyLeHoanThanh",
      //   width: 150,
      //   className: "!py-1",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   render: (text, record: any) => ({
      //     props: {
      //       style: {
      //         textAlign: "right",
      //       },
      //     },
      //     children:
      //       "tyLeHoanThanh" in record ? formatNumber(Number(text), 2) : "-",
      //   }),
      //   onCell: (text, record) => sharedOnCell(text, record),
      // },
      // Tick hoàn thành
      // {
      //   title: "Tick hoàn thành",
      //   dataIndex: "tickHTCD",
      //   key: "tickHTCD",
      //   width: 150,
      //   className: "!py-1",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   render: (text, record) => ({
      //     props: {
      //       style: {
      //         textAlign: "center",
      //       },
      //     },
      //     children: text,
      //   }),
      //   onCell: (text, record) => sharedOnCell(text, record),
      // },
      // ĐVT 2
      // {
      //   title: "ĐVT",
      //   dataIndex: "dvT2",
      //   key: "dvT2",
      //   width: 80,
      //   className: "!py-1",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   render: (text, record) => text,
      //   onCell: (text, record) => sharedOnCell(text, record),
      // },

      // Thời gian còn lại\n(Tính theo số lượng phát lệnh của công đoạn sau gia công in)
      // {
      //   title:
      //     "Thời gian còn lại\n(Tính theo số lượng phát lệnh của công đoạn sau gia công in)",
      //   className: "!py-1 whitespace-pre-line",
      //   key: "tgConLaiGCI",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   children: [
      //     {
      //       title: "Giờ",
      //       dataIndex: "soGioConLaiKeHoach",
      //       key: "soGioConLaiKeHoach",
      //       width: 150,
      //       className: "!py-1",
      //       render: (text, record: any) =>
      //         "soGioConLaiKeHoach" in record ? (
      //           record.thuTuCongDoan === "Tổng cộng" ? (
      //             <div className="font-bold">
      //               {text !== "-" ? formatNumber(Number(text), 0) : "-"}
      //             </div>
      //           ) : text !== "-" ? (
      //             formatNumber(Number(text), 0)
      //           ) : (
      //             "-"
      //           )
      //         ) : (
      //           "-"
      //         ),
      //       onCell: (record: any) => ({
      //         style: {
      //           textAlign: "right",
      //           backgroundColor:
      //             record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
      //               ? "#D9E1F2"
      //               : "white",
      //         },
      //       }),
      //     },
      //     {
      //       title: "Phút",
      //       dataIndex: "soPhutConLaiKeHoach",
      //       key: "soPhutConLaiKeHoach",
      //       width: 150,
      //       className: "!py-1",
      //       render: (text, record: any) =>
      //         "soPhutConLaiKeHoach" in record ? (
      //           record.thuTuCongDoan === "Tổng cộng" ? (
      //             <div className="font-bold">
      //               {text !== "-" ? formatNumber(Number(text), 0) : "-"}
      //             </div>
      //           ) : text !== "-" ? (
      //             formatNumber(Number(text), 0)
      //           ) : (
      //             "-"
      //           )
      //         ) : (
      //           "-"
      //         ),
      //       onCell: (record: any) => ({
      //         style: {
      //           textAlign: "right",
      //           backgroundColor:
      //             record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
      //               ? "#D9E1F2"
      //               : "white",
      //         },
      //       }),
      //     },
      //   ],
      // },
      // Thời gian còn lại\n(Tính theo sản lượng thực tế của các công đoạn sau gia công in)
      // {
      //   title:
      //     "Thời gian còn lại\n(Tính theo sản lượng thực tế của các công đoạn sau gia công in)",
      //   className: "!py-1 whitespace-pre-line",
      //   key: "tgConLai3",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   children: [
      //     {
      //       title: "Giờ",
      //       dataIndex: "soGioConLai3",
      //       key: "soGioConLai3",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },
      //       render: (text, record: any) =>
      //         typeof text === "number" ? (
      //           record.thuTuCongDoan === "Tổng cộng" ? (
      //             <div className="font-bold">
      //               {formatNumber(Number(text), 0)}
      //             </div>
      //           ) : (
      //             formatNumber(Number(text), 0)
      //           )
      //         ) : (
      //           "-"
      //         ),
      //       onCell: (record: any) => ({
      //         style: {
      //           textAlign: "right",
      //           backgroundColor:
      //             record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
      //               ? "#D9E1F2"
      //               : "white",
      //         },
      //       }),
      //     },
      //     {
      //       title: "Phút",
      //       dataIndex: "soPhutConLai3",
      //       key: "soPhutConLai3",
      //       width: 150,
      //       className: "!py-1",
      //       fieldProps: {
      //         moneySymbol: false,
      //         precision: 0,
      //       },
      //       render: (text, record: any) =>
      //         typeof text === "number" ? (
      //           record.thuTuCongDoan === "Tổng cộng" ? (
      //             <div className="font-bold">
      //               {formatNumber(Number(text), 0)}
      //             </div>
      //           ) : (
      //             text
      //           )
      //         ) : (
      //           "-"
      //         ),
      //       onCell: (record: any) => ({
      //         style: {
      //           textAlign: "right",
      //           backgroundColor:
      //             record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
      //               ? "#D9E1F2"
      //               : "white",
      //         },
      //       }),
      //     },
      //   ],
      // },
      // Thời gian chênh lệch (giờ phút)
      // {
      //   title: "Thời gian chênh lệch\n(Các công đoạn sau gia công in)",
      //   className: "!py-1 whitespace-pre-line",
      //   key: "tgCLGCI",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   children: [
      //     {
      //       title: "Giờ",
      //       dataIndex: "soGioChenhLech",
      //       key: "soGioChenhLech",
      //       width: 150,
      //       className: "!py-1",
      //       render: (text, record: any) =>
      //         typeof text === "number" ? (
      //           record.thuTuCongDoan === "Tổng cộng" ? (
      //             <div className="font-bold">
      //               {" "}
      //               {formatNumber(Number(text), 0)}
      //             </div>
      //           ) : (
      //             formatNumber(Number(text), 0)
      //           )
      //         ) : (
      //           "-"
      //         ),
      //       onCell: (record: any) => ({
      //         style: {
      //           textAlign: "right",
      //           backgroundColor:
      //             record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
      //               ? "#D9E1F2"
      //               : "white",
      //         },
      //       }),
      //     },
      //     {
      //       title: "Phút",
      //       dataIndex: "soPhutChenhLech",
      //       key: "soPhutChenhLech",
      //       width: 150,
      //       className: "!py-1",
      //       render: (text, record: any) =>
      //         typeof text === "number" ? (
      //           record.thuTuCongDoan === "Tổng cộng" ? (
      //             <div className="font-bold">
      //               {formatNumber(Number(text), 0)}
      //             </div>
      //           ) : (
      //             text
      //           )
      //         ) : (
      //           "-"
      //         ),
      //       onCell: (record: any) => ({
      //         style: {
      //           textAlign: "right",
      //           backgroundColor:
      //             record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
      //               ? "#D9E1F2"
      //               : "white",
      //         },
      //       }),
      //     },
      //   ],
      // },
      // Phần trăm chênh lệch
      // {
      //   title: "Tỷ lệ chênh lệch thời gian\n(Đã SX thực tế/Đã SX kế hoạch)(%)",
      //   dataIndex: "tyLeChenhLech",
      //   key: "tyLeChenhLech",
      //   width: 160,
      //   className: "!py-1 whitespace-pre-line",
      //   hideInTable: true,
      //   hideInSetting: true,
      //   render: (text, record: any) =>
      //     text !== "-" ? formatNumber(Number(text), 2) : "-",
      //   onCell: (record: any) => ({
      //     style: {
      //       textAlign: "right",
      //       backgroundColor:
      //         record.thuTuCongDoan && record.thuTuCongDoan === "Tổng cộng"
      //           ? "#D9E1F2"
      //           : "white",
      //     },
      //   }),
      // },
    ]);

    const getDateByCommon = async (type: 'ngayRaLSX' |
      "ngayGiaoHangDuKien" |
      "ngayYeuCauNhapKho" |
      "ngayDuKienHoanThanhLSX", common?: string) => {
      if (common && common !== "Custom") {
        await commonDatePresenter.getDataByCommonDate(commonDateStore, common);
        formSearch.setFieldValue(`${type}Tu`, dayjs(commonDateStore.commonDate.fromDate))
        formSearch.setFieldValue(`${type}Den`, dayjs(commonDateStore.commonDate.toDate))
      } else {
        formSearch.setFieldValue(`${type}Tu`, undefined)
        formSearch.setFieldValue(`${type}Den`, undefined)
      }
    }
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //====================================================================================//

    //========================================================================================================== //
    //-------------------------------------------MẪU BÁO CÁO-------------------------------------------------//
    //========================================================================================================== //

    const tableRef = useRef<ActionType>();

    // Name data save to localstorage
    const constDataName = "bc-03";

    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      setIsResizablePresent,
      handleResize,
    } = useResizableColumns<BC03>(columns, setColumns, constDataName);


    const [modalOpen, setModalOpen] = useState(false);
    const [currentList, setCurrentList] = useState<any[]>([]);


    //=======================XXX========================XXX=========================XXX========================= //

    return (
      <div className="w-full  py-3 px-5">
        <SearchCollapse title="BC03. Báo cáo cảnh báo tiến độ đơn hàng">
          <Form
            className="grid grid-cols-2 [&_.ant-form-item]:!mb-2"
            layout="horizontal"
            colon={false}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
            form={formSearch}
            onFinish={(value) => {
              const valueSubmit: any = Object.fromEntries(
                Object.entries(value)
                  .filter(([_, v]) => v !== undefined && v !== '') // Loại bỏ các giá trị undefined
                  .map(([k, v]) => [k, dayjs.isDayjs(v) ? v.format('YYYY-MM-DD') : v]) // Định dạng các đối tượng dayjs
              );
              setSearch({ paging: initialSearch.paging, ...valueSubmit })
              tableRef.current?.reload()
            }}
          >
            <Form.Item name={'khachHang'} label={<strong>Khách hàng</strong>}>
              <Select
                mode="multiple"
                options={dropdownCustomer?.map(c => ({
                  label: c.value,
                  value: c.key
                }))}
                allowClear
                showSearch
                onSearch={(value) => searchCustomer(value)}
                placeholder="Vui lòng chọn"
              />
            </Form.Item>
            <Form.Item name={'tenTPBTP'} label={<strong>Tên TP/BTP</strong>}>
              <Input placeholder="Nhập Tên TP/BTP" />
            </Form.Item>
            <Form.Item name={'maTPBTP'} label={<strong>Mã TP/BTP</strong>}>
              <Input placeholder="Nhập Mã TP/BTP" />
            </Form.Item>
            <Form.Item name={'soCode'} label={<strong>Số SO</strong>}>
              <Input placeholder="Nhập Số SO" />
            </Form.Item>
            <Form.Item name={'lsxTongHop'} label={<strong>Số WO tổng hợp</strong>}>
              <Input placeholder="Nhập Số WO tổng hợp" />
            </Form.Item>
            <Form.Item name={'lsx'} label={<strong>Số WO</strong>}>
              <Input placeholder="Nhập Số WO" />
            </Form.Item>

            {/* ======================= Ngày ban hành===================================== */}
            <Form.Item name={'commonNgayRaLSX'} label={<strong>Ngày ban hành WO</strong>}>
              <Select options={listCommonDate.map(i => ({
                label: i.value,
                value: i.key
              }))}
                allowClear
                onChange={(value) => getDateByCommon('ngayRaLSX', value)}
              />
            </Form.Item>
            <Form.Item name={'ngayRaLSXTu'} label={<strong>Từ ngày</strong>} className="col-start-1">
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayRaLSX === 'Custom' || !!commonNgayRaLSX}
              />
            </Form.Item>
            <Form.Item name={'ngayRaLSXDen'} label={<strong>Đến ngày</strong>}>
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayRaLSX === 'Custom' || !!commonNgayRaLSX}
              />
            </Form.Item>

            {/*====================== Trạng thái WO ==========================*/}
            <Form.Item name={'trangThaiMES'} label={<strong>Trạng thái WO</strong>}>
              <Select
                mode="multiple"
                options={listStatus.map(i => ({
                  label: i.value,
                  value: i.key
                }))} />
            </Form.Item>
            {/*====================== Tiến độ đơn hàng ==========================*/}
            <Form.Item name={'tienDoDonHang'} label={<strong>Tiến độ đơn hàng</strong>}>
              <Select
                mode="multiple"
                options={orderProcessData.map(i => ({
                  label: i.value,
                  value: i.key
                }))} />
            </Form.Item>

            {/*================ Ngày Y/C nhập kho theo SO ====================*/}
            <Form.Item name={'commonNgayGiaoHangDuKien'} label={<strong>Ngày Y/C nhập kho theo SO</strong>} className="col-start-1">
              <Select options={listCommonDateFuture.map(i => ({
                label: i.value,
                value: i.key
              }))}
                allowClear
                onChange={(value) => getDateByCommon('ngayGiaoHangDuKien', value)}
              />
            </Form.Item>
            <Form.Item name={'ngayGiaoHangDuKienTu'} label={<strong>Từ ngày</strong>} className="col-start-1">
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayGiaoHangDuKien === 'Custom' || !!commonNgayGiaoHangDuKien}
              />
            </Form.Item>
            <Form.Item name={'ngayGiaoHangDuKienDen'} label={<strong>Đến ngày</strong>}>
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayGiaoHangDuKien === 'Custom' || !!commonNgayGiaoHangDuKien}
              />
            </Form.Item>

            {/* ========================Ngày Y/C nhập kho theo KH =================================== */}
            <Form.Item name={'commonNgayYeuCauNhapKho'} label={<strong>Ngày Y/C nhập kho theo KH</strong>}>
              <Select options={listCommonDateFuture.map(i => ({
                label: i.value,
                value: i.key
              }))}
                allowClear
                onChange={(value) => getDateByCommon('ngayYeuCauNhapKho', value)}
              />
            </Form.Item>
            <Form.Item name={'ngayYeuCauNhapKhoTu'} label={<strong>Từ ngày</strong>} className="col-start-1">
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayYeuCauNhapKho === 'Custom' || !!commonNgayYeuCauNhapKho}
              />
            </Form.Item>
            <Form.Item name={'ngayYeuCauNhapKhoDen'} label={<strong>Đến ngày</strong>}>
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayYeuCauNhapKho === 'Custom' || !!commonNgayYeuCauNhapKho}
              />
            </Form.Item>

            {/* =====================Ngày hoàn thành SX dự kiến theo ghi nhận thực tế */}
            <Form.Item name={'commonNgayDuKienHoanThanhLSX'} label={<strong>Ngày TH SX dự kiến theo ghi nhận thực tế</strong>}>
              <Select options={listCommonDateFuture.map(i => ({
                label: i.value,
                value: i.key
              }))}
                allowClear
                onChange={(value) => getDateByCommon('ngayDuKienHoanThanhLSX', value)}
              />
            </Form.Item>
            <Form.Item name={'ngayDuKienHoanThanhLSXTu'} label={<strong>Từ ngày</strong>} className="col-start-1">
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayDuKienHoanThanhLSX === 'Custom' || !!commonNgayDuKienHoanThanhLSX}
              />
            </Form.Item>
            <Form.Item name={'ngayDuKienHoanThanhLSXDen'} label={<strong>Đến ngày</strong>}>
              <DatePicker
                format={'DD/MM/YYYY'}
                style={{ width: '100%' }}
                placeholder="dd/mm/yyyy"
                changeOnBlur
                disabled={commonNgayDuKienHoanThanhLSX === 'Custom' || !!commonNgayDuKienHoanThanhLSX}
              />
            </Form.Item>
            {/* =========XEM THEO================= */}
            <Form.Item name='type' label={<strong>Xem theo</strong>}  >
              <Radio.Group>
                <Radio className="!text-default" value={"TH"}>
                  Tổng hợp
                </Radio>
                <Radio className="!text-default" value={"CT"}>
                  Chi tiết công đoạn
                </Radio>
              </Radio.Group>
            </Form.Item>
            <div className="w-full flex justify-center col-span-2">
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>

          </Form>
        </SearchCollapse>
        <Spin spinning={loading}>
          <Wrapper>
            {/* bảng chú thích */}
            <CustomProTable<BC03>
              columns={columns}
              handleResize={handleResize}
              className={`[&_.ant-pro-table-list-toolbar-left]:max-w-full [&_.ant-pro-table-list-toolbar-container]:!items-end ${loading ? 'opacity-0' : 'opacity-100'} delay-300 duration-300 [&_.ant-pro-table-list-toolbar-container]:block`}
              headerTitle={
                <div className="bg-white mb-3 flex">
                  <div className="grid grid-cols-7 gap-4 !z-50">
                    {/* chú thích WO */}
                    <table
                      width={400}
                      className="h-fit col-span-2 bg-white text-default table-auto space-collapse"
                    >
                      <thead className="text-white !bg-[#1677ff]">
                        <tr>
                          <th
                            className="font-semibold border border-border_input"
                            colSpan={2}
                          >
                            Chú thích WO
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderProcessData.map((item) => {
                          return (
                            <tr key={item.key}>
                              <td
                                className="px-2 border border-border_input"
                                width={100}
                                style={{
                                  color: item.color
                                }}
                              >
                                {item.value}
                              </td>
                              <td
                                // style={{ background: item.color }}
                                className={"border border-border_input px-2"}
                              >
                                {item.subValue}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {/* Chú thích công đoạn */}
                    <table
                      width={200}
                      className="h-fit bg-white text-default table-auto space-collapse"
                    >
                      <thead className="text-white !bg-[#1677ff]">
                        <tr>
                          <th
                            className="font-semibold border border-border_input"
                            colSpan={2}
                          >
                            Chú thích công đoạn
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {chuThichCongDoan.map((item) => {
                          return (
                            <tr key={item.key}>
                              <td
                                className="px-2 border border-border_input"
                                width={50}
                                style={{
                                  background: item.color
                                }}
                              >
                              </td>
                              <td
                                // style={{ background: item.color }}
                                className={"border border-border_input px-2"}
                              >
                                {item.value}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {/* bảng cảnh báo tắc nghẽn */}
                    <div className="col-span-4 mt-3.5 lg:mt-0">
                      <div className="grid grid-cols-2">
                        {search.khachHang?.length && (
                          <div className="col-span-1 grid grid-cols-4 text-xs  text-default">
                            <p className="whitespace-nowrap col-span-1">Khách hàng:</p>
                            <p className='font-bold col-span-3'>{search.khachHang.join(', ')}</p>
                          </div>
                        )}
                        {search.lsxTongHop && (
                          <div className="col-span-1 grid grid-cols-4 text-xs  text-default">
                            <p className="col-span-1">Số WO tổng hợp:</p>
                            <p className='font-bold col-span-3'>{search.lsxTongHop}</p>
                          </div>
                        )}
                        {search?.lsx ? (
                          <div className="col-span-1 grid grid-cols-4 text-xs  text-default">
                            <p className="col-span-1">Số WO:</p>
                            <p className='font-bold col-span-3'>{search?.lsx}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {search?.soCode ? (
                          <div className="col-span-1 grid grid-cols-4 text-xs  text-default">
                            <p className="col-span-1">Số WO:</p>
                            <p className='font-bold col-span-3'>{search?.soCode}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {(search.maTPBTP || search.tenTPBTP) && (
                          <div className="col-span-1 grid grid-cols-4 text-xs  text-default">
                            <p className="col-span-1">TP/BTP:</p>
                            <p className='font-bold col-span-3'>{search.maTPBTP} {search.tenTPBTP}</p>
                          </div>
                        )}
                        {search?.tienDoDonHang?.length ? (
                          <div className="col-span-1 grid grid-cols-4 text-xs  text-default">
                            <p className="col-span-1 whitespace-nowrap">Tiến độ đơn hàng:</p>
                            <p className='font-bold col-span-3'>
                              {orderProcessData
                                .filter((item) => {
                                  return search.tienDoDonHang?.includes(item.key)
                                }
                                )
                                .map((i) => i.value)
                                .join(", ")}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {search?.trangThaiMES?.length ? (
                          <div className="col-span-1 gap-2 grid grid-cols-4 text-xs  text-default">
                            <p className="col-span-1">Trạng thái WO:</p>
                            <p className='font-bold col-span-3'>
                              {listStatus
                                .filter((s) =>
                                  search?.trangThaiMES?.includes(s.key)
                                )
                                .map((i) => i.value)
                                .join(", ")}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {(search.ngayGiaoHangDuKienTu ||
                          search.ngayGiaoHangDuKienDen) && (
                            <div className="col-span-2">
                              <p className="text-xs  text-default">
                                Ngày Y/C nhập kho
                              </p>
                              <p className="text-xs  text-default">
                                Từ ngày:{" "}
                                <strong>
                                  {search.ngayGiaoHangDuKienTu
                                    ? moment(search.ngayGiaoHangDuKienTu).format(
                                      "DD/MM/YYYY"
                                    )
                                    : ""}
                                </strong>{" "}
                                &emsp;&emsp;&emsp;&emsp; Đến ngày:{" "}
                                <strong>
                                  {search.ngayGiaoHangDuKienDen
                                    ? moment(search.ngayGiaoHangDuKienDen).format(
                                      "DD/MM/YYYY"
                                    )
                                    : ""}
                                </strong>
                              </p>
                            </div>
                          )}
                        {(search.ngayRaLSXTu || search.ngayRaLSXDen) && (
                          <div className="col-span-2">
                            <p className="text-xs  text-default">
                              Ngày ban hành WO
                            </p>
                            <p className="text-xs  text-default">
                              Từ ngày:{" "}
                              <strong>
                                {search.ngayRaLSXTu
                                  ? moment(search.ngayRaLSXTu).format(
                                    "DD/MM/YYYY"
                                  )
                                  : ""}
                              </strong>{" "}
                              &emsp;&emsp;&emsp;&emsp; Đến ngày:{" "}
                              <strong>
                                {search.ngayRaLSXDen
                                  ? moment(search.ngayRaLSXDen).format(
                                    "DD/MM/YYYY"
                                  )
                                  : ""}
                              </strong>
                            </p>
                          </div>
                        )}
                        {(search.ngayYeuCauNhapKhoTu || search.ngayYeuCauNhapKhoDen) && (
                          <div className="col-span-2">
                            <p className="text-xs  text-default">
                              Ngày Y/C nhập kho theo KH
                            </p>
                            <p className="text-xs  text-default">
                              Từ ngày:{" "}
                              <strong>
                                {search.ngayYeuCauNhapKhoTu
                                  ? moment(search.ngayYeuCauNhapKhoTu).format(
                                    "DD/MM/YYYY"
                                  )
                                  : ""}
                              </strong>{" "}
                              &emsp;&emsp;&emsp;&emsp; Đến ngày:{" "}
                              <strong>
                                {search.ngayYeuCauNhapKhoDen
                                  ? moment(search.ngayYeuCauNhapKhoDen).format(
                                    "DD/MM/YYYY"
                                  )
                                  : ""}
                              </strong>
                            </p>
                          </div>
                        )}
                        {(search.ngayDuKienHoanThanhLSXTu || search.ngayDuKienHoanThanhLSXDen) && (
                          <div className="col-span-2">
                            <p className="text-xs  text-default">
                              Ngày TH SX dự kiến theo ghi nhận thực tế
                            </p>
                            <p className="text-xs  text-default">
                              Từ ngày:{" "}
                              <strong>
                                {search.ngayDuKienHoanThanhLSXTu
                                  ? moment(search.ngayDuKienHoanThanhLSXTu).format(
                                    "DD/MM/YYYY"
                                  )
                                  : ""}
                              </strong>{" "}
                              &emsp;&emsp;&emsp;&emsp; Đến ngày:{" "}
                              <strong>
                                {search.ngayDuKienHoanThanhLSXDen
                                  ? moment(search.ngayDuKienHoanThanhLSXDen).format(
                                    "DD/MM/YYYY"
                                  )
                                  : ""}
                              </strong>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              }
              isResizablePresent={isResizablePresent}
              resizableColumnSelect={resizableColumnSelect}
              request={async (params = {}, sort, filter) => {
                const data = await getListReport({
                  ...search,
                  paging: {
                    ...search.paging,
                    orderBy:
                      Object.values(sort)[0] === "ascend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                    orderByDesc:
                      Object.values(sort)[0] === "descend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                  },
                });
                if (Object.values(sort).length) {
                  setSearch({
                    ...search,
                    paging: {
                      ...search.paging,
                      orderBy:
                        Object.values(sort)[0] === "ascend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                      orderByDesc:
                        Object.values(sort)[0] === "descend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                    },
                  });
                }
                setLoading(false);
                return {
                  data: data,
                  success: reportStore.BC03Response.isSuccess,
                };
              }}
              scroll={{ x: 2600, y: 500 }}
              dataSource={dataTable.map((data) => data)}
              actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
              columnsState={{
                value:
                  Object.keys(columnsState).length > 0
                    ? columnsState
                    : undefined,
                onChange: (newColumnsState) => {
                  handleColumnsStateChange(newColumnsState);
                },
              }}
              rowKey={"key"}
              expandable={{
                expandedRowKeys: [...dataTable.map((i) => i.stt + "")],
                expandIcon: () => {
                  return <></>;
                },
              }}
              pagination={{
                pageSize: search.paging.pageSize,
                total: reportStore.BC03Response.paging?.totalCount,
                current: search.paging.pageIndex,
                responsive: true,
                pageSizeOptions: [10, 25, 50, 100],
                showSizeChanger: true,
                position: ["topRight"],
                style: { margin: "10px 0" },
                showTotal: (total, range) =>
                  `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
                onChange: (page, pageSize) => {
                  setSearch({
                    ...search,
                    paging: {
                      ...search.paging,
                      pageIndex: page,
                      pageSize: pageSize,
                    },
                  });
                },
              }}
              dateFormatter="string"
              toolBarRender={() => [
                <Button
                  size="middle"
                  loading={isLoading}
                  className="bg-blue-500 !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                  onClick={async () => {
                    setIsLoading(true);
                    await reportPresenter.exportExcelBC03({ ...search });
                    setIsLoading(false);
                  }}
                  type="primary"
                >
                  <AiOutlineDownload className="block text-base" />
                  <span className="block">Export Excel</span>
                </Button>,
                <SaveReportForm
                  templateReportModalRef={templateReportModalRef}
                  userReports={userReports}
                  selectedReportId={selectedReportId}
                  setIsResizablePresent={setIsResizablePresent}
                />,
              ]}
            />
          </Wrapper>
        </Spin>
        <TemplateReportModal
          ref={templateReportModalRef}
          {...templateReportModalProps}
        />



        <Modal
          title="Thông tin máy/chuyền thực hiện"
          centered
          open={modalOpen}
          okButtonProps={{
            style: {
              display: 'none'
            }
          }}
          cancelButtonProps={{
            style: {
              display: 'none'
            }
          }}
          onOk={() => setModalOpen(false)}

          onCancel={() => setModalOpen(false)}
        >
          <ModalDetail currentList={currentList} />
        </Modal>
      </div>
    );
  });
}
